import React, { memo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import hasIn from 'lodash/hasIn';

import {
  EmptyState,
  Loading,
  PageSubTitle
} from '../../common/Elements/Elements';
import ChildrenTable from './parts/ChildrenTable/ChildrenTable';
import { Donut3Colors, TextWidget } from '../../common/charts/charts';
import { Area } from '../../common/charts/charts';

import { postRequest } from 'utils/requests';
import { moneyFormaterFull } from 'utils/common';
import { textChartFormatData } from './helpers/helpers';

import classes from './Children.module.scss';

const Children = ({ customerId }) => {
  const [childrenData, setChildrenData] = useState({});
  const [loader, setLoader] = useState(true);
  const [dataConection, setDataConection] = useState(true);

  const { t } = useTranslation(['activity']);

  useEffect(() => {
    let cancelled = false;
    postRequest('/customer/children', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          setChildrenData(res.body);
          setDataConection(true);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
          setDataConection(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  const chartData = {
    values: {
      valueMax: hasIn(childrenData, 'headerData.accountUsage.tenants')
        ? childrenData.headerData.accountUsage.tenants
        : 0,
      essential: hasIn(childrenData, 'headerData.plans.essential.count')
        ? childrenData.headerData.plans.essential.count
        : 0,
      standard: hasIn(childrenData, 'headerData.plans.standard.count')
        ? childrenData.headerData.plans.standard.count
        : 0,
      premium: hasIn(childrenData, 'headerData.plans.premium.count')
        ? childrenData.headerData.plans.premium.count
        : 0,
      enterprice: hasIn(childrenData, 'headerData.plans.enterprice.count')
        ? childrenData.headerData.plans.enterprice.count
        : 0
    },
    valueLabel: t('activity:customers.TENANTS'),
    infoData: {
      licenses: textChartFormatData(
        hasIn(childrenData, 'headerData.accountUsage.tm')
          ? childrenData.headerData.accountUsage.tm
          : 'NA'
      ),
      gateways: textChartFormatData(
        hasIn(childrenData, 'headerData.accountUsage.ps')
          ? childrenData.headerData.accountUsage.ps
          : 'NA'
      ),
      percent: hasIn(childrenData, 'headerData.accountUsage.tmP')
        ? childrenData.headerData.accountUsage.tmP
        : 0
    }
  };

  const essential = {
    title: t('activity:customers.ESSENTIALS'),
    value: hasIn(childrenData, 'headerData.plans.essential.count')
      ? childrenData.headerData.plans.essential.count
      : 0,
    users: hasIn(childrenData, 'headerData.plans.essential.tmUtilized')
      ? childrenData.headerData.plans.essential.tmUtilized
      : 0,
    gateways: hasIn(childrenData, 'headerData.plans.essential.psUtilized')
      ? childrenData.headerData.plans.essential.psUtilized
      : 0
  };
  const standard = {
    title: t('activity:customers.STANDART'),
    value: hasIn(childrenData, 'headerData.plans.standard.count')
      ? childrenData.headerData.plans.standard.count
      : 0,
    users: hasIn(childrenData, 'headerData.plans.standard.tmUtilized')
      ? childrenData.headerData.plans.standard.tmUtilized
      : 0,
    gateways: hasIn(childrenData, 'headerData.plans.standard.psUtilized')
      ? childrenData.headerData.plans.standard.psUtilized
      : 0
  };
  const premium = {
    title: t('activity:customers.PREMIUM'),
    value: hasIn(childrenData, 'headerData.plans.premium.count')
      ? childrenData.headerData.plans.premium.count
      : 0,
    users: hasIn(childrenData, 'headerData.plans.premium.tmUtilized')
      ? childrenData.headerData.plans.premium.tmUtilized
      : 0,
    gateways: hasIn(childrenData, 'headerData.plans.premium.psUtilized')
      ? childrenData.headerData.plans.premium.psUtilized
      : 0
  };
  const enterprice = {
    title: t('activity:customers.ENTERPRISE'),
    value: hasIn(childrenData, 'headerData.plans.enterprise.count')
      ? childrenData.headerData.plans.enterprise.count
      : 0,
    users: hasIn(childrenData, 'headerData.plans.enterprise.tmUtilized')
      ? childrenData.headerData.plans.enterprise.tmUtilized
      : 0,
    gateways: hasIn(childrenData, 'headerData.plans.enterprise.psUtilized')
      ? childrenData.headerData.plans.enterprise.psUtilized
      : 0
  };

  const forArr = arArr => {
    return arArr.length > 0 ? arArr[arArr.length - 1].arr : arArr;
  };

  const areaChart = {
    title: t('activity:customers.ARR'),
    contentText: hasIn(childrenData, 'headerData.arrGraphic')
      ? moneyFormaterFull(forArr(childrenData.headerData.arrGraphic))
      : 0,
    arr: hasIn(childrenData, 'headerData.arrGraphic')
      ? childrenData.headerData.arrGraphic
      : []
  };

  if (loader) {
    return <Loading />;
  }

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <PageSubTitle hiden title="Arr Informaton" />
      <div className={classes.charts}>
        <Donut3Colors chartData={chartData} />
        <TextWidget data={essential} />
        <TextWidget data={standard} />
        <TextWidget data={premium} />
        <TextWidget data={enterprice} />
        <Area areaChartData={areaChart} />
      </div>
      <ChildrenTable tableData={childrenData.tableData} />
    </>
  );
};

Children.propTypes = {
  customerId: PropTypes.string
};

export default memo(Children);
